import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { logout } from 'store/utilisateur/courantActions';
import { UtilisateurCourantContext } from 'context/UtilisateurCourantContext';

import NavBar from './NavBar';


const NavBarContainer = ({ logout, isLoginPage }) => {

    const utilisateurCourantContext = useContext(UtilisateurCourantContext);


    const handleLogout = () => {
        // Suppression des données de l'utilisateur courant dans le localStorage
        logout();

        // Suppression dans le contexte
        utilisateurCourantContext.setUtilisateur(null);

    };

    return (<NavBar logout={handleLogout} isLoginPage={isLoginPage}/>);
};

NavBarContainer.propTypes = {
    logout: PropTypes.func.isRequired,
    isLoginPage: PropTypes.bool
};

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logout())
});

export default connect(null, mapDispatchToProps)(NavBarContainer);